import { useEffect, useRef } from 'react';
import { BaseLineLoading2 } from '@/app/components/icons/BaseLineLoading2';

// LoadingTrigger 组件：监听可见性并触发加载
interface LoadingTriggerProps {
  folderId: string;
  onTrigger: (folderId: string) => void;
}

export const LoadingTrigger: React.FC<LoadingTriggerProps> = ({ folderId, onTrigger }) => {
  const triggerRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    const element = triggerRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          onTrigger(folderId);
        }
      },
      {
        threshold: 0,
      },
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [folderId, onTrigger]);

  return <BaseLineLoading2 ref={triggerRef} className="size-4 animate-spin" />;
};
